<template>
    <b-modal :id="$id('advancedSettingsModal')" :visible="visible" centered no-close-on-backdrop>
        <template #modal-header="{ close }">
            <b-row class="w-100 p-0 m-0 h-100 " align-v="center">
                <b-col class="text-left">
                    <!-- 'Modal.Title' -> "Options Avancées" -->
                    <h6>{{ $t('Modal.Title') }}</h6>
                </b-col>
                <!-- Close -> "Fermer" -->
                <b-col class=" pr-0 p-1 pl-4 text-right">
                    <b-icon role="button" icon="x-lg" font-scale="1.5" @click="close(); visible = false;resetSettings()" v-b-tooltip.hover :title="$t('Close')" />
                </b-col>
            </b-row>
        </template>
        
        <template #modal-footer="{ok,close}">
            <b-row>
                <!-- Cancel -> "Annuler" -->
                <b-button @click="close(); visible = false;resetSettings()" :variant="'outline-' + Variant" pill class="mr-1">{{ $t('Cancel') }}</b-button>
                <!-- Validate -> "Valider" -->
                <b-button @click="ok(); visible = false;validateSettings()" pill :variant="Variant">{{ $t('Validate') }}</b-button>
            </b-row>
        </template>
        
        <!-- generateVariantStyle() permet de générer les variables Css dynamiques utilisables dans la section <style></style> -->
        <div :style="generateVariantStyle(Variant)">
            <!-- TODO : Revoir options avancées pour eviter les v-if / v-else -->
            <template v-if="HandleByMetersVisible">
                <template>
                    <b-row align-h="between">
                        <b-col>
                            <label>{{ $t('HandleMeters.Title') }}</label>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-checkbox @change="updateSelectedSettings('isHandleByMeters', isHandleByMeters)" :id="$id('isHandleByMeters')" v-model="isHandleByMeters" switch/>
                        </b-col>
                    </b-row>
                </template>
            </template>
            <template v-else>
                <!-- Correction dégré jour -->
                <template>
                    <b-row align-h="between"  >
                        <b-col>
                            <!-- DegreeDays.Title' -> "Correction Degrés Jour" -->
                            <label :for="$id('correctors')">{{ $t('DegreeDays.Title') }}</label>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-checkbox @change="updateSelectedSettings('isCorrector', isCorrector)" :id="$id('correctors')" v-model="isCorrector" switch  />
                        </b-col>
                    </b-row>
                    
                    <!-- Type Correcteur -->
                    <b-row class="py-2 pl-2" v-if="isCorrector">
                        <b-button @click="getCorrectorsValue" v-for="(btn, index) in correctorsButtons" :key="index" :pressed.sync="btn.state" variant="outline-gray-dark" class="h-100 mr-1 text-black" >{{ btn.Label }}</b-button>
                    </b-row>
                </template>
                
                <!-- Année Glissante -->
                <template>
                    <b-row align-h="between" >
                        <b-col>
                            <!-- Settings.SlidingYear' -> "Dernière année glissante" -->
                            <label :for="$id('slidingYear')">{{ $t('Settings.SlidingYear') }}</label>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-checkbox @change="updateSelectedSettings('isSlidingYear', isSlidingYear)" :id="$id('slidingYear')" v-model="isSlidingYear" switch :disabled="SynthesisType == 'Statement' || SynthesisType == 'Distributor'" />
                        </b-col>
                    </b-row>
                </template>

                <!-- Factures comptabilisées -->
                <template>
                    <b-row align-h="between">
                        <b-col>
                            <!-- Settings.AccountingInvoices -> "Uniquement factures comptabilisées" -->
                            <label :for="$id('isAccounting')">{{ $t('Settings.AccountingInvoices') }}</label>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-checkbox @change="updateSelectedSettings('isAccounting', isAccounting)" :id="$id('isAccounting')" v-model="isAccounting" switch :disabled="SynthesisType == 'Statement' || SynthesisType == 'Distributor'" />
                        </b-col>
                    </b-row>    
                </template>

                <!-- Sans facture estimée -->
                <template>
                    <b-row align-h="between" >
                        <b-col>
                            <!-- Settings.WithoutEstimated' -> "Sans facture estimée" -->
                            <label :for="$id('withoutestimated')">{{ $t('Settings.WithoutEstimated') }}</label>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-checkbox @change="updateSelectedSettings('isWithoutEstimated', isWithoutEstimated)" :id="$id('withoutestimated')" v-model="isWithoutEstimated" switch :disabled="SynthesisType == 'Statement' || SynthesisType == 'Distributor'" />
                        </b-col>
                    </b-row>
                </template>

                <!-- Options d'affichage -->
                <template v-if="DisplaySettingsVisible"><!-- Feature != 'Benchmarking' -->
                    <b-row class="border-top pt-1">
                        <b-col>
                            <!-- 'Display.Title' -> "Affichage" -->
                            <label>{{ $t('Display.Title') }}</label>
                        </b-col>
                    </b-row>
                    
                    <b-row class="py-2 pl-2">
                        <!-- Display.Options.Compared' -> "Comparé" -->
                        <!-- <b-button @click="updateSelectedSettings('isCompare', !isCompare)" :pressed.sync="isCompare" :disabled="isDissociate" variant="outline-gray-dark" class="h-100 mr-1 text-black">Comparé</b-button> -->
                        <!-- 'Display.Options.Dissociated' -> "Dissocié" -->
                        <b-button @click="updateSelectedSettings('isDissociate', !isDissociate)" :pressed.sync="isDissociate" :disabled="isCompare" variant="outline-gray-dark" class="h-100 mr-1 text-black">{{ $t('Display.Options.Dissociated') }}</b-button>
                        <!-- Display.Options.Cumulated' -> "Cumulé" -->
                        <b-button @click="updateSelectedSettings('isCumulated', !isCumulated)" :pressed.sync="isCumulated" variant="outline-gray-dark" class="text-black">{{ $t('Display.Options.Cumulated') }}</b-button>
                    </b-row>
                </template>
            </template>   
        </div>
    </b-modal>
</template>

<script lang="ts">
    import { PropSync, Prop, Watch } from 'vue-property-decorator';
    import Component, { mixins } from 'vue-class-component';
    import { ThemeUtils } from "@/components/commons/Utils";

    /** Traductions */
    import locales from "./locales/AdvancedSettings.json";

    /** Permet d'afficher une modale pour les options avancées */
    @Component({
        components: {

        },
        i18n: { messages: locales }
    })
    export default class AdvancedSettings extends mixins(ThemeUtils) {
		/** Variant de couleur à appliquer sur le composant */
		@Prop({ default: () => "secondary"})
		public Variant!: string;

        /** Permet d'afficher ou non la modale */
        @PropSync('Visible', {default: () => false})
        public visible!: boolean;

        /** Indique si on prend en compte la dernière année glissante */
        @PropSync('SlidingYear', { default: () => false })
        public isSlidingYear!: boolean;

        /** Indique si on ne prend pas en compte les factures estimées*/
        @PropSync('WithoutEstimated', { default: () => true })
        public isWithoutEstimated!: boolean;

        /** Indique si on prend uniquement les factures comptabilisées */
        @PropSync("IsAccounting", { default: () => false })
        public isAccounting!: boolean;

        /** Indique si la correction degrés jour est active ou non */
        @PropSync('IsCorrector', { default: () => false })
        public isCorrector!: boolean;

        /** Indique si la partie gérant les valeurs de isHandleByMeters est visible ou non */
        @Prop({ default: () => false })
        public HandleByMetersVisible!: boolean;

        /** Indique si on doit prendre en compte les compteurs ou uniquement le noeud sélectionné */
        @PropSync("IsHandleByMeters", {default : () => false })
        public isHandleByMeters!: boolean;

        /** Liste de correcteurs sélectionnés  */
        @PropSync("Correctors", {default: () => ""})
        public correctors!: string;

        /** Permet de récupérer le type de synthèse sélectionné */
        @Prop()
        public SynthesisType!: string;

        /** Indique si la partie des options d'affichage est visible ou non */
        @Prop({ default: () => false })
        public DisplaySettingsVisible!: boolean;

        /** Liste des boutons pour la correction DJU */
        private correctorsButtons: { Id: number, Label: string, state: boolean }[] = [
             // 'Correctors.Types.Heating' -> "Chauffage"
            { Id: 1, Label: this.$t('Correctors.Types.Heating').toString(), state: false },
            // 'Correctors.Types.AirConditioning' -> "Climatisation"
            { Id: 7, Label: this.$t('Correctors.Types.AirConditioning').toString(), state: false }
        ]

        /**
         * Permet d'obtenir la liste des types de correcteurs DJU sélectionnés
         */
         public getCorrectorsValue() {

            let selectedCorrectors: { Id: number, Label: string, state: boolean }[] = this.correctorsButtons.filter(btn => btn.state);
            let sCorrector: string = "";

            console.debug("AdvancedSettings - getCorrectorsValue - selectedCorrectors - ", selectedCorrectors);
            console.debug("AdvancedSettings - getCorrectorsValue - selectedCorrectors - ", selectedCorrectors.length);

            for (let i = 0; i < selectedCorrectors.length; i++) {
                sCorrector += selectedCorrectors[i].Id + ",";
            }

            console.debug("AdvancedSettings - getCorrectorsValue - sCorrectors ", sCorrector);

            sCorrector = sCorrector.endsWith(',') ? sCorrector.substr(0, sCorrector.length - 1) : sCorrector;

            this.currentSettings.find(x => x.Name == "isCorrector").Values = sCorrector;

            console.debug("AdvancedSettings - getCorrectorsValue - correctors - ", this.correctors);
        }

        // #endregion Options Avancées

        // #region Affichage

        @PropSync("Compare", { default: () => false })
        public isCompare!: boolean;

        @PropSync("Dissociate", { default: () => false })
        public isDissociate!: boolean;

        @PropSync("Cumulate", { default: () => false })
        public isCumulated!: boolean;

        /**
         * Liste des options sélectionnées 
         */
        @PropSync("SelectedSettings", {default: () => []})
        public selectedSettings !: {Name: string, Values : string}[];
    
        private currentSettings : {Name: string, Values : string}[] = [];


        /** Permet la mise à jour de la sélection des type de correcteurs DJU */
        //@Watch('currentSettings.isCorrector', { immediate: true, deep : true })
        private updateCorrectors() {
            let currentCorrectors : {Name: string, Values : string} = this.currentSettings.find(x => x.Name == "isCorrector");    

            if(currentCorrectors) {
                // On vérifie si le bouton 'Correction Degrés Jour' est bien coché vu que des correcteurs sont cochés
                if (!this.isCorrector)
                    this.isCorrector = true;

                console.debug("AdvancedSettings - updateCorrectors - %O", this.currentSettings.find(x => x.Name == "isCorrector"));

                let correctorValues : string[] = currentCorrectors.Values.split(',');
            
                correctorValues.forEach((el) => {
                    let correctorBtn = this.correctorsButtons.find(c => c.Id.toString() == el)  
                
                    if(correctorBtn)
                        correctorBtn.state = true;      
                });
            }
        }

        /**
         * Met à jour la liste des options sélectionnées
         * @param name 
         * @param value 
         */
        private updateSelectedSettings(name : string, value : boolean ){
            
            console.debug("AdvancedSettings - updateSelectedSettings - name", name);
            console.debug("AdvancedSettings - updateSelectedSettings - value", value);
            
            // Si non existant
            if(value){
                this.currentSettings.push({Name: name, Values: ""});

                console.debug("AdvancedSettings - updateSelectedSettings - selectedSettings", this.currentSettings);

                if(name == "isCorrector"){                    
                    this.correctorsButtons.forEach( x => x.state = true);
                    this.getCorrectorsValue();
                }
            }
            else{
                let setting = this.currentSettings.findIndex(x => x.Name == name);
                
                console.debug("AdvancedSettings - updateSelectedSettings - setting", setting);

                this.currentSettings.splice(setting, 1);

                // Désélection des boutons correction DJU
                if(name == "isCorrector"){
                    this.correctors = "";
                    this.correctorsButtons.forEach( x => x.state = false);
                }
            }
        }

        /** Permet d'affecter la sélection courante aux options avancés */
        private validateSettings(){
            this.selectedSettings = this.currentSettings;

            if(this.currentSettings.find(x => x.Name == "isCorrector"))
                this.correctors = this.currentSettings.find(x => x.Name == "isCorrector").Values;
        }

        /** Permet de retourner à l'état avant modification des options avancées */
        private resetSettings(){
            // Compare les 2 tableaux et regarder les différences 
            let r = this.currentSettings.filter(c => !this.selectedSettings.some(s => c.Name === s.Name))

            console.debug("AdvancedSettings - resetSettings - r : %O", r);

            console.debug("AdvancedSettings - resetSettings - select : %O", this.selectedSettings);

            r.forEach(el => {
                console.debug("AdvancedSettings - resetSettings - el.Name : %O", el.Name);

                if(el.Name == "isCorrector") {
                    // On change la valeur des correcteurs pour correspondre à ceux de la sélection à l'ouverture de la modale.
                    let correctorList = this.selectedSettings.find(x => x.Name == "isCorrector");
                    this.isCorrector = false;

                    if(correctorList && correctorList.Values.length == 0)
                        this.correctors = "";
                }

                if(el.Name == "isSlidingYear")
                    this.isSlidingYear = false;

                if(el.Name == "isWithoutEstimated")
                    this.isWithoutEstimated = false;

                if(el.Name == "isAccounting")
                    this.isAccounting = false;

                if(el.Name == "isDissociate")
                    this.isDissociate = false;

                if(el.Name == "isCumulated")
                    this.isCumulated = false;  
            });
        }

        public created() {
            // on met une copie de la sélection des paramètres enregistrés dans la sélection courante

            this.currentSettings = JSON.parse(JSON.stringify(this.selectedSettings));
            this.updateCorrectors();

            this.currentSettings.forEach(el => {
                if(el.Name == "isSlidingYear")
                    this.isSlidingYear = true;

                if(el.Name == "isWithoutEstimated")
                    this.isWithoutEstimated = true;

                if(el.Name == "isAccounting")
                    this.isAccounting = true;

                if(el.Name == "isDissociate")
                    this.isDissociate = true;

                if(el.Name == "isCumulated")
                    this.isCumulated = true;
            })


            console.debug("AdvancedSettings - mounted - currentSettigngs : %O", this.currentSettings);
        }
    }
</script>

<style scoped>

    /** Style appliquée pour les boutons sélectionnées */
    :deep(.btn.active) {
            background-color: var(--VariantLight) !important;  
            color: var(--VariantDark) !important;
            border-color: var(--Variant) !important;
        }

    /* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est coché */
    :deep(.custom-control-input:checked ~ .custom-control-label::before) {
            border-color: var(--Variant) !important;
            background-color: var(--Variant) !important;
        }

    /* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est actif */
    :deep(.custom-control-input:active ~ .custom-control-label::before) {
        background-color: var(--Variant) !important;
        border-color: var(--Variant) !important;
    }
</style>